import { useState } from 'react';

import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from '@mui/material';
import { useTranslate } from 'react-admin';

import { flowchartLogger } from 'src/lib/logger';

import NodeControlForm from '../NodeControlForm';

import type { NodeControlsProps } from '../../dataProvider/types';

export interface AiVoiceAnalysisData extends Record<string, unknown> {
  action: 'start' | 'stop';
}

interface AiVoiceAnalysisControlsProps extends NodeControlsProps {
  updateNodeData: (data: Record<string, unknown>) => void;
  data: AiVoiceAnalysisData;
}

export default function AiVoiceAnalysisControls({
  updateNodeData,
  data,
}: AiVoiceAnalysisControlsProps): React.ReactElement {
  const [action, setAction] = useState<AiVoiceAnalysisData['action']>(data.action ?? 'start');
  const translate = useTranslate();

  const onAiVoiceAnalysisDataUpdate = (event: React.MouseEvent | React.FormEvent): void => {
    event.preventDefault();
    flowchartLogger.debug('AiVoiceAnalysisControls: onAiVoiceAnalysisDataUpdate', { action });
    updateNodeData({ action });
  };

  return (
    <NodeControlForm onSubmit={onAiVoiceAnalysisDataUpdate} data={data} updateNodeData={updateNodeData}>
      <FormControl sx={{ display: 'flex', flexDirection: 'column' }} variant='outlined'>
        <InputLabel id='ai-voice-analysis-controls-action-label'>
          {translate('callflows.nodes.ai_voice_analysis.action')}
        </InputLabel>
        <Select
          labelId='ai-voice-analysis-controls-action-label'
          value={action}
          label={translate('callflows.nodes.ai_voice_analysis.action')}
          onChange={(event) => {
            setAction(event.target.value);
          }}
        >
          <MenuItem value='start'>{translate('callflows.nodes.ai_voice_analysis.actionStart')}</MenuItem>
          <MenuItem value='stop'>{translate('callflows.nodes.ai_voice_analysis.actionStop')}</MenuItem>
        </Select>
        <FormHelperText>{translate('callflows.nodes.ai_voice_analysis.actionDescription')}</FormHelperText>
      </FormControl>
    </NodeControlForm>
  );
}
